import React, { useContext } from 'react'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'
import { QuestionMarkCircleIcon, ChevronUpIcon, ChevronDownIcon, ArrowPathRoundedSquareIcon, DocumentDuplicateIcon, TrashIcon } from '@heroicons/react/24/outline'

import ExerciseCardDetailsButton from '../Buttons/Exercise/ExerciseCardDetailsButton'

import ExerciseSetsButton from '../Buttons/Exercise/ExerciseSetsButton'
import ExerciseSetUnitsButton from '../Buttons/Exercise/ExerciseSetUnitsButton'

import FloatingMenuEllipsisButton from '../Buttons/FloatingMenuEllipsisButton'

import ExerciseNoteInputBox from '../InputBoxes/ExerciseNoteInputBox'
import ContinuousOverrideComponent from '../Components/ContinuousOverrideComponent'

import SetDetailCards from '../Components/SetDetailCards'

import AddSetButton from '../Buttons/Set/AddSetButton'

import RestCard from './RestCard'

export default function ExerciseCard({ phase, phaseIndex, exercise, exerciseIndex, showRest }) {
    const { ShowModal } = useContext(ModalContext)
    const { mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    const exerciseSettings = [
        {
            color: 'gray',
            icon: QuestionMarkCircleIcon,
            text: 'View Parameters',
            action: () => ShowExerciseParametersModal(),
        },
        {
            color: 'gray',
            icon: ChevronUpIcon,
            text: 'Move Exercise Up',
            action: () => mutateExercise('position-up', phaseIndex, exerciseIndex),
        },
        {
            color: 'gray',
            icon: ChevronDownIcon,
            text: 'Move Exercise Down',
            action: () => mutateExercise('position-down', phaseIndex, exerciseIndex),
        },
        {
            color: 'gray',
            icon: ArrowPathRoundedSquareIcon,
            text: 'Swap Exercise',
            action: () => ShowSwapExerciseModal(),
        },
        {
            color: 'gray',
            icon: DocumentDuplicateIcon,
            text: 'Duplicate Exercise',
            action: () => mutateExercise('duplicate-exercise', phaseIndex, exerciseIndex),
        },
        {
            color: 'red',
            icon: TrashIcon,
            text: 'Delete Exercise',
            action: () => mutateExercise('delete-exercise', phaseIndex, exerciseIndex),
        },
    ]

    const ShowExerciseParametersModal = () => {
        if (exercise.generationVariables !== undefined) {
            var bodyText = []

            // For hard-coded or static
            if (exercise.generationVariables.progressionType === 'hard-coded' || exercise.generationVariables.progressionType === 'static') {
                bodyText.push('Progression Type: ' + exercise.generationVariables.progressionType)
            }

            if (exercise.generationVariables.progressionType === 'single-category') {
                bodyText.push('Progression Type: ' + exercise.generationVariables.progressionType)
                bodyText.push('Category: ' + exercise.generationVariables.category)
                bodyText.push('Progression Level: ' + exercise.generationVariables.progressionLevel)
            }

            if (exercise.generationVariables.progressionType === 'multi-category') {
                bodyText.push('Progression Type: ' + exercise.generationVariables.progressionType)
                bodyText.push('Location: ' + exercise.generationVariables.location)
                bodyText.push('Category: ' + exercise.generationVariables.category)
                bodyText.push('Progression Level: ' + exercise.generationVariables.progressionLevel)
                bodyText.push('Body Part 1: ' + exercise.generationVariables.bodyPart1)
                bodyText.push('Function 1: ' + exercise.generationVariables.function1)
                bodyText.push('Sport: ' + exercise.generationVariables.sport)
            }

            const modalData = {
                key: ModalKey.Text,
                size: 'half',
                titleText: 'Exercise Parameters',
                bodyText: bodyText,
            }

            ShowModal(modalData)
        }
    }

    const ShowSwapExerciseModal = () => {
        const modalData = {
            key: ModalKey.SelectExercise,
            titleText: 'Select An Exercise',
            size: 'half',
            buttonAction: (exercise) => mutateExercise('swap-exercise', phaseIndex, exerciseIndex, null, exercise),
        }

        ShowModal(modalData)
    }

    return (
        <div className={exercise.id === -1 ? 'bg-red-100 min-h-8' : 'min-h-8'}>
            {/* Exercise Card Header */}
            <div className="flex items-center border-t border-stone-400">
                {/* Exercise Name and Expand/Collapse Button */}
                <ExerciseCardDetailsButton phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />

                {/* Right Hand Side */}
                <div className="flex items-center">
                    {/* Sets Button component. Hide when showing details */}
                    <ExerciseSetsButton phase={phase} phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />

                    {/* Reps Button component. Hide when showing details */}
                    <ExerciseSetUnitsButton phase={phase} phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />

                    {/* Exercise Settings button */}
                    <FloatingMenuEllipsisButton settings={exerciseSettings} />
                </div>
            </div>

            {/* Expanded Sets and Reps */}
            {exercise.showDetails && (
                <div className="bg-gray-50 rounded-b-lg">
                    {/* Exercise Note */}
                    <ExerciseNoteInputBox phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />

                    {/* Continuous Override Component */}
                    <ContinuousOverrideComponent phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />

                    {/* Set Detail Cards */}
                    <SetDetailCards phase={phase} phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />

                    {/* Add Set Button */}
                    <AddSetButton phase={phase} phaseIndex={phaseIndex} exerciseIndex={exerciseIndex} />
                </div>
            )}

            {/* Rest Card */}
            {showRest && <RestCard phaseIndex={phaseIndex} exercise={exercise} exerciseIndex={exerciseIndex} />}
        </div>
    )
}
